import { NgModule } from '@angular/core';
import { RouterModule, type Routes } from '@angular/router';
import { AuthCallbackComponent } from '../components/auth-callback/auth-callback.component';
import { LoginPageComponent } from '../components/login-page/login-page.component';
import {ForgotPasswordComponent} from "../components/forgot-password/forgot-password.component";

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/authentication/login' },
  { path: 'login', component: LoginPageComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'auth-callback', component: AuthCallbackComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OdinAuthenticationRoutingModule {}
